import common from "./common.json";

export const zh = {
  common,
};
